import type { SVGProps } from "react";

export function IconDarkPurpleStar(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6191_12553)">
        <path
          d="M14.9682 3.31515C15.6076 1.34708 18.3919 1.34708 19.0314 3.31515L21.476 10.839L29.387 10.839C31.4564 10.839 32.3168 13.487 30.6426 14.7033L24.2425 19.3533L26.6871 26.8771C27.3266 28.8452 25.0741 30.4818 23.3999 29.2654L16.9998 24.6154L10.5996 29.2654C8.92549 30.4818 6.67295 28.8452 7.31242 26.8771L9.75705 19.3533L3.35691 14.7033C1.68277 13.487 2.54316 10.839 4.61251 10.839L12.5235 10.839L14.9682 3.31515Z"
          stroke="#3E2247"
          strokeWidth="2.0625"
        />
      </g>
      <defs>
        <clipPath id="clip0_6191_12553">
          <rect width="33" height="33" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
